import { createSlice } from '@reduxjs/toolkit';

const deckSlice = createSlice({
    name: 'deck',
    initialState: {
        selectedDeck: null, // весь объект колоды, а не только идентификатор
    },
    reducers: {
        setDeck(state, action) {
            state.selectedDeck = action.payload;
        },
    },
});

export const { setDeck } = deckSlice.actions;
export default deckSlice.reducer;
